module.exports = __webpack_public_path__ + "static/media/tti_resume@3x.811b7d21.png";